import { render, staticRenderFns } from "./leadWay.vue?vue&type=template&id=4c8755a5&scoped=true"
import script from "./leadWay.vue?vue&type=script&lang=js"
export * from "./leadWay.vue?vue&type=script&lang=js"
import style0 from "./leadWay.vue?vue&type=style&index=0&id=4c8755a5&prod&scoped=true&lang=scss"
import style1 from "./leadWay.vue?vue&type=style&index=1&id=4c8755a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8755a5",
  null
  
)

export default component.exports